import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';
declare var initFlowbite: any;

@Component({
  selector: 'section-m',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-m.component.html',
  styleUrl: './section-m.component.css'
})
export class SectionMComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection15 = new EventEmitter<any>();

  @ViewChild('datepickerDeterminationDate') datepickerDeterminationDate!: ElementRef;
  yesNo = EYesNo;

  sectionMForm: FormGroup = new FormGroup({});

  questionsList = [
    {
      questionText: "A. Person/situation appears to pose a clear and immediate threat of serious violence toward others that requires containment and action to protect identified target(s).",
      descriptors: "A targeted attack is imminent (can occur at any moment).",
      requirement: "Immediate containment. Action to protect targets. Immediate intervention by Law Enforcement. Make necessary notifications to appropriate parties (i.e., potential victims, school staff members, district personnel). Additional Response, Management, and Support Plan work should continue only after immediate threat has been resolved. Re-entry meeting will be necessary before student can return to school.",
      value: "1",
    },
    {
      questionText: "B. Person/situation appears to pose a threat of violence, exhibiting behaviors that indicate both a continuing intent to harm and efforts to acquire the capacity to carry out the plan.",
      descriptors: "Threat is direct, specific, and plausible (likely, probable, or possible without appropriate intervention). Threat suggests concrete steps have been taken toward carrying out an attack, awareness that the student who made the threat has acquired or practiced with a weapon, or has had the victim under surveilance.",
      requirement: "Development of a Response, Management, and Support Plan.",
      value: "2"
    },
    {
      questionText: "C. Person/situation does not appear to pose a threat of violence at this time, but exhibits behaviors that indicate a continuing intent to harm and potential for future violence.",
      descriptors: "Wording in the threat suggests that the student who made the threat has given some thought to how the act will be carried out. There may be a general indication of a possible place and time, though without specific details. There is strong indication that the student who made the threat has taken preparatory steps, although there may be some veiled reference or ambiguous or inconclusive evidence pointing to that possibility. There may be a specific statement seeking to convey that the threat is not empty.",
      requirement: "Development of a Response, Management, and Support Plan.",
      value: "3"
    },
    {
      questionText: "D. Person/situation does not appear to pose a threat of violence and the team believes the matter can be resolved with the development of a Response, Management, and Support Plan.",
      descriptors: "Threat is vague and indirect. Information contained within the threat is inconsistent, implausible, or lacks detail. Threat lacks realism Content of the threat suggests the person is unlikely to ocarry it out.",
      requirement: "Development of a Response, Management, and Support Plan.",
      value: "4"
    }
  ]

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      initFlowbite();
    }
    this.initializeForm();    
    this.onChanges();
  }  
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }
  
  private initializeForm(): void {
    // radio input for each question
    this.sectionMForm = new FormGroup({
      team_determination: new FormControl(String(this.fullTeamAssessmentData?.team_determination) || this.yesNo.No, Validators.required),
      team_determination_selection: new FormControl({value: String(this.fullTeamAssessmentData?.team_determination_selection) || null, disabled: String(this.fullTeamAssessmentData?.team_determination) != this.yesNo.Yes ? true : false}),
      team_determination_plan_date: new FormControl({value: this.fullTeamAssessmentData?.team_determination_plan_date || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), disabled: this.fullTeamAssessmentData?.team_determination == this.yesNo.Yes}),
    })

    this.onChanges(); 
  }

  onChanges(): void {
    this.sectionMForm.get('team_determination')!.valueChanges.subscribe(val => {
      if (val == this.yesNo.No) {
        // enable datepicker and set validators
        this.sectionMForm.get('team_determination_plan_date')?.enable();
        this.sectionMForm.get('team_determination_plan_date')?.setValue(DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()));
        this.sectionMForm.get('team_determination_plan_date')?.setValidators(Validators.required);
        this.sectionMForm.get('team_determination_selection')?.setValue(null);
        this.sectionMForm.get('team_determination_selection')?.disable();
        this.sectionMForm.get('team_determination_selection')?.clearValidators();
      } else {
        // disable datepicker and remove validators and enable selection
        this.sectionMForm.get('team_determination_plan_date')?.disable();
        this.sectionMForm.get('team_determination_plan_date')?.setValue(null);
        this.sectionMForm.get('team_determination_plan_date')?.clearValidators();
        
        this.sectionMForm.get('team_determination_selection')?.setValue('1');
        this.sectionMForm.get('team_determination_selection')?.enable();
        this.sectionMForm.get('team_determination_selection')?.setValidators(Validators.required);

      }
      this.cdr.detectChanges(); // Manually trigger change detection
      this.initializeDatepicker();
    });
  }  

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeDatepicker();
    }
  } 

  async initializeDatepicker() {
    const { Datepicker } = await import('flowbite-datepicker');
    if (this.datepickerDeterminationDate?.nativeElement) {
      new Datepicker(this.datepickerDeterminationDate.nativeElement, {
        autohide: true,
        format: 'mm/dd/yyyy'
      });
      // set default value to display for incident date
      if (this.fullTeamAssessmentData?.team_determination_plan_date) {
        // if date_of_incident is available, set it to the datepicker
        this.datepickerDeterminationDate.nativeElement.value = DateUtils.formatDateForDisplay(this.fullTeamAssessmentData.team_determination_plan_date);
      } else {
        // if date_of_incident is not available, set it to the current date
        this.datepickerDeterminationDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
      }
      this.datepickerDeterminationDate.nativeElement.addEventListener('changeDate', (event: any) => {
        const formattedDate = DateUtils.formatDateForBackend(event.target.value);
        this.sectionMForm.get('team_determination_plan_date')?.setValue(formattedDate);
      });
    }
  }

  saveSectionM(): void {
    if (this.sectionMForm.valid) {
      this.onSaveSection15.emit(this.sectionMForm.value);
    }
  }

}
